import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CommonTaskStatus } from '@euler/model/enum';
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

export const StatusLabel = ({
  status,
  continuable,
  continueText = '继续检测',
  style,
  text,
  textStyle,
  onPress,
}: {
  status: CommonTaskStatus;
  continuable?: boolean;
  continueText?: string;
  text?: string;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  onPress?: () => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        padding: 0 ${rpx(8)}px;
        height: ${rpx(20)}px;
        border-radius: ${rpx(10)}px;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: ${status === CommonTaskStatus.Pending
          ? '#fbb03b'
          : status === CommonTaskStatus.InProgress
          ? '#4f01bb'
          : '#00AA55'};
      `}
      style={style}
    >
      {onPress != null ? (
        <TouchableOpacity onPress={onPress} style={StyleSheet.absoluteFill} />
      ) : null}
      <Text
        css={`
          font-family: ${FontFamily.NotoSans.Light};
          font-size: ${rpx(11)}px;
          line-height: ${rpx(16)}px;
          color: #fff;
        `}
        style={textStyle}
      >
        {text ??
          (status === CommonTaskStatus.Pending
            ? '未开始'
            : status === CommonTaskStatus.InProgress
            ? continuable
              ? continueText
              : '进行中'
            : '已完成')}
      </Text>
    </View>
  );
};
